<template>
  <div id="app">
    
    
    <ImageLoader></ImageLoader>
    <div class="debug" style="opacity:.1;" @click="toggleDebug">version {{version}}</div>
    <div v-if="welcome" class="login" @click="doLogin">Player : {{welcome}}</div>
    <div v-else class="login" @click="doLogin">login</div>
     <div v-if=" currentPage!='Credits'" class="credits"><a  class="noLink" href="/credits" target="_blank">Credits</a></div>
     <div v-else @click="windowClose"  class="credits">Close</div>
    <div v-if="showSignIn" class="signin">
      <SignUp></SignUp>
    </div>
    <div v-if="!hideNav" id="nav">
     
      <router-link to="/">Home</router-link> |
      <router-link to="/about">About</router-link> |
      <router-link to="/credits">Credits</router-link> |
      <router-link to="/help">Help</router-link> |
      <router-link to="/documents">Documents</router-link> |
       <router-link to="/lighthouse">Lighthouse</router-link> |
       <router-link to="/wrecklink">Diagrams</router-link> |
      <router-link to="/dive">Dive Test</router-link> | 
      <router-link to="/ship">Ship</router-link>
      
      
    </div>
    <router-view/>
     <CircleTrans></CircleTrans>
    
    
     
      <Settings></Settings>
      
      <Action></Action>
      <Help></Help>
       <notification style="z-index:10;"></notification> 
      	<audio ref="gameAudio" loop  src="../src/assets/audio/CaveAmbience.mp3" ></audio>
        <audio ref="caveAudio" loop  src="../src/assets/audio/CaveDrops.mp3" ></audio>
        <audio ref="shipAudio" loop  src="../src/assets/audio/FishingBoat.mp3" ></audio>
        <audio ref="diveAudio" loop  src="../src/assets/audio/Underwater.mp3" ></audio>
        <audio ref="roomAudio" loop  src="../src/assets/audio/Room2.mp3" ></audio>
        
      <div v-if="isUnavailable && !isTester" class="unavailable" ref="unavailable">Available Christmas 2020
        <div @click="goDive" style="font-size:15px;margin-top: 10px;margin-bottom: 20px;">[ Wreck Preview ]</div>
         <div @click="closeUnavailable" style="font-size:20px;">[ Close ]</div>
      </div>
      
  </div>
</template>
<script>
import notification from '@/components/notification'
import CircleTrans from "@/components/panels/Transition.vue";
import Help from "@/components/panels/Help.vue";
import Settings from "@/components/panels/Settings.vue";
import Action from "@/components/panels/Action.vue";
import ImageLoader from '@/components/panels/ImageLoader'
import SignUp from '@/components/panels/SignUp'
export default {
   components: {ImageLoader,CircleTrans,Help,Action,Settings,SignUp,notification},
  data: () => ({
    audios:["gameAudio","caveAudio","shipAudio","diveAudio","roomAudio"]
  }),
  mounted(){
    this.setVolume(this.fxVolume)
    //this.setAudio()
  },
  computed:{
    FXAudio(){
      let FXAudio=this.$store.getters.getFXAudio
      return this.$refs[FXAudio]
      
    },
    fxVolume(){
      			return this.$store.getters.getFXVolume
    		},
    isTester(){
      return this.$store.getters.getIsTester
    },
    activeWreck(){
      return this.$store.getters.getActiveWreck
    },
    isUnavailable(){
      return this.$store.getters.getIsUnavailable
    },
    wrecks(){
       return this.$store.getters.getWrecks
    },
    currentWreck(){
      return this.$store.getters.getWreck
    },
    gameStatus(){
				return this.$store.getters.getGameStatus
      },
      
    viewedDocs(){
      return this.$store.getters.getViewedDocs
    },
    knownDocs(){
      return this.$store.getters.getKnownDocs
    },
    
    userData(){
      return this.$store.getters.getUserData

    },
    userIsLoaded(){
        return this.$store.getters.getUserIsLoaded
      },
    welcome(){
      if(this.userIsLoaded){
        return this.userData.name
      }
    },
    showSignIn(){
      return this.$store.getters.showSignIn
    },
    version(){
      return this.$store.getters.getVersion
    },
    debug(){
      return this.$store.getters.getDebug
    },
    hideNav(){
      return this.currentPage!="Documents" && this.currentPage!="About"
    },
    currentPage(){
      console.log(this.$route.name)
      return this.$route.name
    }
  },
  methods:{
    windowClose(){
      window.close();
    },
    doHelpClick(){
      this.$store.getters.getHelpClick()
    },
    goDive(){
      
      this.$store.commit("setDiveModel",null)
      this.$store.commit("setIsUnavailable",false)
      this.$router.push({ path: "dive"})
    },
    closeUnavailable(){
      if(this.$store.getters.getIsTester){
        alert("OK I will continue because you are a tester")
        this.$store.commit("setIsUnavailable",false)
      }else{
        this.$store.commit("setWreck",null)
        this.$store.commit("setIsUnavailable",false)
      }
      //location.reload();
    },
    doLogin(){
      this.$store.commit("setShowSignIn",true)
    },
    toggleDebug(){
      this.$store.commit('setDebug',!this.debug)
    },
    setVolume(val){
      for(var a in this.audios){
        this.$refs[this.audios[a]].volume=val
      }
    }
  },
  watch:{
    fxVolume(val){
      this.setVolume(val)
		},
    activeWreck(val){
      if(val!=this.selectedWreck){
        this.$store.commit("setMapArea",null)
        this.$store.commit("setExhibitionLoaded",false)
        this.$store.commit('setWreckByName',val.activeWreck)
        //alert("Wreck Swapped")
        
      }
    },
    
    gameStatus(val){
				if(val.activeWreck!=this.selectedWreck){
          // alert("Wreck Swapped 2")
				// 	this.$store.commit('setWreckByName',val.activeWreck)
				}	
      },
    currentPage(val){
     
      for(var a in this.audios){
        this.$refs[this.audios[a]].pause()
      }
      this.$store.dispatch("stopHelp")
      switch(val){
        case "Game2":
          this.$refs.gameAudio.play()
           this.$refs.caveAudio.play()
          //this.FXAudio.play()
          break;
          case "Ship":
          this.$refs.shipAudio.play()
          break;
          case "Dive":
          this.$refs.diveAudio.play()
          break;
          case "Planning":
          this.$refs.roomAudio.play()
          break;
          case "ExhibitPlan":
          this.$refs.roomAudio.play()
          break;
          case "Exhibition":
          this.$refs.roomAudio.play()
          break;
          
          
         
      }
      //alert(this.FXAudio)
      //this.FXAudio.play()
      this.gameStatus.currentPage=val
      this.$store.dispatch('saveGameState')
    },
    viewedDocs(val){
      this.$store.dispatch('updateUserData',{viewedDocs:val})
    },
    knownDocs(val){
      this.$store.dispatch('updateUserData',{knownDocs:val})
    },
    
    userData(val){
      if(val && val.activeWreck!=this.selectedWreck){
					this.$store.commit('setWreckByName',val.activeWreck)
				
				
				}
      
      if(val){
              this.$store.dispatch('updateUserData',{plays:val.plays+1})
      }
    }
  }
}
</script>
<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Orbitron:wght@700&display=swap');
 @import "@/assets/sass/variables.scss";
body, html{
   height:100%;
}

#app {
  position:relative;
  
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  height:100%;
  overflow: hidden;
}
#nav {
  padding: 15px;
}
#nav a {
  font-weight: bold;
  color: #2c3e50;
}
#nav a.router-link-exact-active {
  color: #42b983;
}
body {
  background-color: #000;
  font-family: "Orbitron";
  padding:0px;
  margin:0px;
  color: #0ff;
}
h1{
  margin-bottom: 0px;
   margin-top: 5px;
}

.page {
  position:relative;
  padding: 20px;
  width: 100%;
  height: 600px;

}
.glowBorder {
  border: solid 3px $glow-colour;
  /*background: $glow-Gradient;
  color: #0bf;
  */
  background-size: 100% 5px;
  box-shadow: 0px 0px 20px 0px, 0px 0px 50px 0px inset;
  border-radius: 5px;
  color: $glow-colour
  
}
.dragable.active {
  border:none!important;
  pointer-events: auto;
}
.menuDragger{
   border:none;
   pointer-events: auto;
}

.mainMenu {
  top:0px;
  right: 0px;
  position: absolute;
  min-width:200px;
 
}

.menuPad{
  display: inline-flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-evenly;
    width: calc( 100% - 260px );
}

.debug{
  color:#fff;
  position:absolute;
  z-index:2;
  opacity:0.5;
  top:0px;
  left:120px;
  background-color:#00000077;
}
.login{
  color:#fff;
  position:absolute;
  z-index:2;
  opacity:0.5;
  top:0px;
  right:20px;
  cursor:pointer;
  background-color:#00000077;
}
.credits{
  color:#fff;
  position:absolute;
  z-index:2;
  
  bottom:10px;
  right:20px;
  cursor:pointer;
  background-color:#00000077;
}
.noLink{
  opacity:0.5;
    color:#fff;
    cursor:pointer;
    text-decoration: none;
  }
 .noLink:hover{
   opacity:1;
 }
.signin{
  color: #fff;
    position: absolute;
    display: flex;
    width: 100%;
    height: 100%;
    z-index: 20;
    opacity: 1;
  background-color:#00000033;
}
.helpIcon{
    background-position: 0px 0px;
    position: absolute;
    top: 20px;
    right: 0px;
    width: 80px;
    height: 80px;
    background-image: url(/img/assistant.f793cd19.png);
    background-size: 80px 80px;
    -webkit-transform: scaleX(-1);
    transform: scaleX(-1);
    background-repeat: no-repeat;
    color: #fff;
    box-shadow: inset #48b6ea 0px 0px 9px 3px;
    border-radius: 50%;
    z-index:3;
}
 .closeBtn{
    color:#fff;
    position: absolute;
    top: 0px;
    right: 0px;
    cursor: pointer;
    width: 28px;
    height: 28px;
    border-radius: 50%;
    text-align: center;
  }
  .closeBtn:hover{
    opacity:1
  }
  .unavailable{
    top:0px;
    position:absolute;
    width:100%;
    height:80%;
    padding-top:20%;
    color:#ffffff;
    font-size:50px;
    background-color:#00000099;
    z-index:3000
  }
  
</style>
